export const mainMenu = () => {
    let mainMenu = document.querySelector('.main-menu');

    if(mainMenu) {
        let mobileMenuBtn = document.getElementById('mobileMenuTrigger');
        let menuItems = mainMenu.querySelectorAll('.submenu');
        let menuItemsBtn = mainMenu.querySelectorAll('.btn-cross');

        mobileMenuBtn.addEventListener('click', openMobileMenu);

        function openMobileMenu() {
            document.body.classList.toggle('mobileMenuActive');
            document.body.classList.toggle('scrollDisable');
            menuItems.forEach((element, index) => {
                element.parentNode.classList.remove('submenu-active');
            });
        }

        function closeMobileMenu() {
            document.body.classList.remove('mobileMenuActive', 'scrollDisable');
            menuItems.forEach((element, index) => {
                element.parentNode.classList.remove('submenu-active');
            });
        }

        menuItemsBtn.forEach((element, index) => {
            element.addEventListener("click", () => {
                element.parentNode.classList.toggle('submenu-active');
            })
        });

        window.addEventListener('resize', ()=> {
            if(document.body.classList.contains('mobileMenuActive')){closeMobileMenu()}
        });
    }
}